// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum TrimLevelsMutationTypes {
    SET_TRIM_LEVELS = 'SET_TRIM_LEVELS',
  }
  